import { createFileRoute } from '@tanstack/react-router'
import { RefundPrintPage } from '../../../../features/refunds/refund-print-page'
import { voucherPrintSearchSchema } from '../../../../features/sales/search'

export const Route = createFileRoute('/_app/refunds/$refundId/print')({
  staticData: { crumb: 'refundPrint' },
  validateSearch: voucherPrintSearchSchema,
  component: RefundPrintPage,
})
